import BaseClass from "./BaseClass";

export default class SharedIntegrations extends BaseClass {
  constructor(data) {
    super(data);
    Object.keys(this.schema).forEach(v => {
      this[v] || this._set(this, v, undefined);
    });
  }

  static get schema() {
    return {
      uuid: { type: String },
      integration_uuid: { type: v => (v ? String(v, null) : v) },
      secret: { type: v => (v ? String(v, null) : v) },
      name: { type: v => (v ? String(v, null) : v) },
      description: { type: v => (v ? String(v, null) : v) },
      state: { type: Number },
      updated_at: { type: v => (v ? String(v, null) : v) },
      version_time: { type: Number },
      type: { type: Number },
      is_editable: { type: v => (typeof v === "boolean" ? Boolean(v) : v) },
      has_widget: { type: v => (typeof v === "boolean" ? Boolean(v) : v) },
      is_enabled: { type: v => (typeof v === "boolean" ? Boolean(v) : v) },
      is_outdated: { type: v => (typeof v === "boolean" ? Boolean(v) : v) },
      has_logo: { type: v => (typeof v === "boolean" ? Boolean(v) : v) },
      langs: { type: v => (v instanceof Array ? v : []) },
      _links: { type: v => (v instanceof Array ? v : []) },
      settings: { type: v => (v instanceof Array ? v : []) },
      scopes: { type: v => (v instanceof Array ? v : []) },
      code: { type: v => (v ? String(v, null) : v) },
      secret_key: { type: v => (v ? String(v, null) : v) },
      sharedAmocrm_uuid: { type: v => (v ? String(v, null) : v) },
      sharedWidgets_uuid: { type: v => (v ? String(v, null) : v) }
    };
  }

  get OAuth() {
    try {
      return this._embedded.sharedOauth[0];
    } catch (e) {
      this._lazyLoadFullData();
    }
    return undefined;
  }

  get OAuthCount() {
    try {
      return this._embedded.sharedOauth.length;
    } catch (e) {
      return 0;
    }
  }

  get sharedCustomersServices() {
    try {
      return this._embedded.sharedCustomersServices[0];
    } catch (e) {
      this._lazyLoadFullData();
    }
    return undefined;
  }

  get sharedCustomersServicesCount() {
    try {
      return this._embedded.sharedCustomersServices.length;
    } catch (e) {
      return 0;
    }
  }

  get image() {
    try {
      return this._embedded.sharedWidgets.logo_main;
    } catch (e) {
      //
    }
    try {
      return this._links.logo.href;
    } catch (e) {
      //
    }
    return require("../../assets/images/fail.svg");
  }

  get amoDomain() {
    try {
      return this._embedded.sharedAmocrm.domain;
    } catch (e) {
      return "";
    }
  }

  get widgetCode() {
    try {
      return this._embedded.sharedWidgets.code;
    } catch (e) {
      return "";
    }
  }

  async _lazyLoadFullData() {
    this._embedded || this._set(this, "_embedded", {});
    let res = (
      await this._api.query({
        query: require("../../graphql/opupet_query.graphql"),
        variables: {
          class: "\\App\\JStorage\\SPA\\JSSharedIntegrations",
          method: "LoadFullData",
          params: [this.uuid]
        }
      })
    ).data.opupet_query;
    Object.assign(this, new this.constructor(res));
  }

  static async loadListWithRelations() {
    return (
      await this._api.query({
        query: require("../../graphql/opupet_query.graphql"),
        variables: {
          class: "\\App\\JStorage\\SPA\\JSSharedIntegrations",
          method: "loadListWithRelations",
          params: []
        }
      })
    ).data.opupet_query;
  }

  async handleDelete() {
    let res = (
      await this._api.query({
        query: require("../../graphql/opupet_query.graphql"),
        variables: {
          class: "\\App\\JStorage\\SPA\\JSSharedIntegrations",
          method: "deleteIntegration",
          params: [this.uuid]
        }
      })
    ).data.opupet_query;
    return res;
  }

  beShownForFilterString(filter, filters_array = []) {
    let result =
      !filter ||
      (this.name || "").toLowerCase().includes(filter.toLowerCase()) ||
      (this.widgetCode || "").toLowerCase().includes(filter.toLowerCase()) ||
      (this.amoDomain || "").toLowerCase().includes(filter.toLowerCase());
    if (result && filters_array.length) {
      try {
        filters_array.forEach(v => {
          if (!this.beShownForFilterString(v)) {
            throw new Error("");
          }
        });
      } catch (e) {
        result = false;
      }
    }

    return result;
  }
}
